// The 66 books with OSIS ids, chapter counts and the abbreviations people
// actually type. Verse-per-chapter counts are not here: they come from the
// bible_verses table once a public-domain text is imported, so the parser
// validates book and chapter and leaves verse upper bounds to the server.
const b = (id, name, testament, chapters, aliases = []) => ({
    id,
    name,
    testament,
    chapters,
    aliases,
});
export const BOOKS = [
    b("Gen", "Genesis", "OT", 50, ["ge", "gn"]),
    b("Exod", "Exodus", "OT", 40, ["ex", "exo"]),
    b("Lev", "Leviticus", "OT", 27, ["le", "lv"]),
    b("Num", "Numbers", "OT", 36, ["nu", "nm", "nb"]),
    b("Deut", "Deuteronomy", "OT", 34, ["dt", "de", "deu"]),
    b("Josh", "Joshua", "OT", 24, ["jos", "jsh"]),
    b("Judg", "Judges", "OT", 21, ["jdg", "jg", "jdgs"]),
    b("Ruth", "Ruth", "OT", 4, ["ru", "rth"]),
    b("1Sam", "1 Samuel", "OT", 31, ["1sa", "1sm", "isam", "isamuel", "firstsamuel"]),
    b("2Sam", "2 Samuel", "OT", 24, ["2sa", "2sm", "iisam", "iisamuel", "secondsamuel"]),
    b("1Kgs", "1 Kings", "OT", 22, ["1ki", "1kg", "1kin", "ikings", "firstkings"]),
    b("2Kgs", "2 Kings", "OT", 25, ["2ki", "2kg", "2kin", "iikings", "secondkings"]),
    b("1Chr", "1 Chronicles", "OT", 29, ["1ch", "1chron", "ichronicles", "firstchronicles"]),
    b("2Chr", "2 Chronicles", "OT", 36, ["2ch", "2chron", "iichronicles", "secondchronicles"]),
    b("Ezra", "Ezra", "OT", 10, ["ezr"]),
    b("Neh", "Nehemiah", "OT", 13, ["ne"]),
    b("Esth", "Esther", "OT", 10, ["es", "est"]),
    b("Job", "Job", "OT", 42, ["jb"]),
    b("Ps", "Psalms", "OT", 150, ["psalm", "psa", "psm", "pss", "pslm"]),
    b("Prov", "Proverbs", "OT", 31, ["pr", "prv", "pro"]),
    b("Eccl", "Ecclesiastes", "OT", 12, ["ec", "ecc", "qoh", "qoheleth"]),
    b("Song", "Song of Solomon", "OT", 8, ["songofsongs", "sos", "so", "canticles", "cant", "ss"]),
    b("Isa", "Isaiah", "OT", 66, ["is"]),
    b("Jer", "Jeremiah", "OT", 52, ["je", "jr"]),
    b("Lam", "Lamentations", "OT", 5, ["la"]),
    b("Ezek", "Ezekiel", "OT", 48, ["eze", "ezk"]),
    b("Dan", "Daniel", "OT", 12, ["da", "dn"]),
    b("Hos", "Hosea", "OT", 14, ["ho"]),
    b("Joel", "Joel", "OT", 3, ["jl"]),
    b("Amos", "Amos", "OT", 9, ["am"]),
    b("Obad", "Obadiah", "OT", 1, ["ob"]),
    b("Jonah", "Jonah", "OT", 4, ["jnh", "jon"]),
    b("Mic", "Micah", "OT", 7, ["mc"]),
    b("Nah", "Nahum", "OT", 3, ["na"]),
    b("Hab", "Habakkuk", "OT", 3, ["hb"]),
    b("Zeph", "Zephaniah", "OT", 3, ["zep", "zp"]),
    b("Hag", "Haggai", "OT", 2, ["hg"]),
    b("Zech", "Zechariah", "OT", 14, ["zec", "zc"]),
    b("Mal", "Malachi", "OT", 4, ["ml"]),
    b("Matt", "Matthew", "NT", 28, ["mt", "mat"]),
    b("Mark", "Mark", "NT", 16, ["mk", "mr", "mrk"]),
    b("Luke", "Luke", "NT", 24, ["lk", "lu"]),
    b("John", "John", "NT", 21, ["jn", "jhn", "joh"]),
    b("Acts", "Acts", "NT", 28, ["ac", "act", "actsoftheapostles"]),
    b("Rom", "Romans", "NT", 16, ["ro", "rm"]),
    b("1Cor", "1 Corinthians", "NT", 16, ["1co", "icor", "icorinthians", "firstcorinthians"]),
    b("2Cor", "2 Corinthians", "NT", 13, ["2co", "iicor", "iicorinthians", "secondcorinthians"]),
    b("Gal", "Galatians", "NT", 6, ["ga"]),
    b("Eph", "Ephesians", "NT", 6, ["ep"]),
    b("Phil", "Philippians", "NT", 4, ["php", "phi", "pp"]),
    b("Col", "Colossians", "NT", 4, ["co"]),
    b("1Thess", "1 Thessalonians", "NT", 5, ["1th", "1thes", "ithess", "ithessalonians", "firstthessalonians"]),
    b("2Thess", "2 Thessalonians", "NT", 3, ["2th", "2thes", "iithess", "iithessalonians", "secondthessalonians"]),
    b("1Tim", "1 Timothy", "NT", 6, ["1ti", "itim", "itimothy", "firsttimothy"]),
    b("2Tim", "2 Timothy", "NT", 4, ["2ti", "iitim", "iitimothy", "secondtimothy"]),
    b("Titus", "Titus", "NT", 3, ["tit", "ti"]),
    b("Phlm", "Philemon", "NT", 1, ["phm", "pm", "philem"]),
    b("Heb", "Hebrews", "NT", 13, ["he"]),
    b("Jas", "James", "NT", 5, ["jm", "jam"]),
    b("1Pet", "1 Peter", "NT", 5, ["1pe", "1pt", "ipet", "ipeter", "firstpeter"]),
    b("2Pet", "2 Peter", "NT", 3, ["2pe", "2pt", "iipet", "iipeter", "secondpeter"]),
    b("1John", "1 John", "NT", 5, ["1jn", "1jo", "1jhn", "ijohn", "firstjohn"]),
    b("2John", "2 John", "NT", 1, ["2jn", "2jo", "2jhn", "iijohn", "secondjohn"]),
    b("3John", "3 John", "NT", 1, ["3jn", "3jo", "3jhn", "iiijohn", "thirdjohn"]),
    b("Jude", "Jude", "NT", 1, ["jud", "jd"]),
    b("Rev", "Revelation", "NT", 22, ["re", "rv", "revelations", "apocalypse", "revelationofjohn"]),
];
const byId = new Map(BOOKS.map((book) => [book.id, book]));
export function bookById(id) {
    return byId.get(id);
}
export function bookIndex(id) {
    return BOOKS.findIndex((book) => book.id === id);
}
/** Every spelling → book, keyed by the normalised form used in refs.ts. */
export const BOOK_LOOKUP = (() => {
    const map = new Map();
    const norm = (s) => s.toLowerCase().replace(/[^a-z0-9]/g, "");
    for (const book of BOOKS) {
        for (const key of [book.id, book.name, ...book.aliases])
            map.set(norm(key), book);
    }
    return map;
})();
//# sourceMappingURL=books.js.map